export function formatOrganisations({ props }) {
  const organisationList = Object.entries(props.response.value || {}).map(
    ([key, { name }]) => ({ key, name })
  );

  return { organisationList };
}
